export default __webpack_public_path__ + "static/media/Name.fa78663b.svg";